import { useState } from "react";

const boardMembers = [
  { name: "HITIMANA Eric", role: "Board Chairperson", department: "Board of Directors", bio: "", image: "/images/team/ERIC-HITIMANA.jpg", initials: "HE", color: "bg-chocolate/20 text-chocolate" },
  { name: "NDAYISENGA Theoneste", role: "Board Vice Chairperson", department: "Board of Directors", bio: "", image: "/images/team/Theoneste.jpeg", initials: "NT", color: "bg-chocolate/20 text-chocolate" },
  { name: "IRACYANKUNDA Lamberthe", role: "Board Secretary", department: "Board of Directors", bio: "", image: "/images/team/iracyankunda-lamberthe.jpg", initials: "IL", color: "bg-forest/20 text-forest" },
  { name: "GATERA Celestin", role: "Board Advisor", department: "Board of Directors", bio: "", image: "/images/team/gatera-celestin.jpeg", initials: "GC", color: "bg-ocean/20 text-ocean" },
  { name: "MUSENGIMANA Colette", role: "Board Advisor", department: "Board of Directors", bio: "", image: "/images/team/musengimana-colette.jpg", initials: "MN", color: "bg-gold/20 text-chocolate" },
];

const auditCommittee = [
  { name: "Alain Patrick RISHIRABAKE", role: "Audit Committee President", department: "Audit Committee", bio: "", image: "/images/team/alain-patrick.jpg", initials: "AP", color: "bg-primary/20 text-primary" },
  { name: "Jean D'arc UZAYISENGA", role: "Audit Committee Member", department: "Audit Committee", bio: "", image: "/images/team/Jean.jpg", initials: "JU", color: "bg-forest/20 text-forest" },
  { name: "Theogene NGENDAHAYO", role: "Audit Committee Member", department: "Audit Committee", bio: "", image: "/images/team/Theogene-ngendahayo.jpg", initials: "TN", color: "bg-chocolate/20 text-chocolate" },
];

const creditCommittee = [
  { name: "Shema VENUTSE", role: "Credit Committee President", department: "Credit Committee", bio: "", image: "/images/team/shema-venuste.jpg", initials: "SV", color: "bg-ocean/20 text-ocean" },
  { name: "UWITIJE Marie Solange", role: "Credit Committee Member", department: "Credit Committee", bio: "", image: "/images/team/uwitije.jpg", initials: "UM", color: "bg-gold/20 text-chocolate" },
  { name: "KUBWIMANA Emmanuel", role: "Credit Committee Member", department: "Credit Committee", bio: "", image: "/images/team/kubwimana-emmanuel.jpg", initials: "KE", color: "bg-primary/20 text-primary" },
  { name: "BARAKA Emmanuel", role: "Credit Committee Member", department: "Credit Committee", bio: "", image: "/images/team/baraka.jpg", initials: "BE", color: "bg-forest/20 text-forest" },
  { name: "UWINGABIRE Angelique", role: "Credit Committee Member", department: "Credit Committee", bio: "", image: "/images/team/uwingabire-angelique.jpg", initials: "UA", color: "bg-chocolate/20 text-chocolate" },
];

const loanRecoveryCommittee = [
  { name: "TUYIZERE Narcisse", role: "Recovery Committee Member", department: "Loan Recovery Committee", bio: "", image: "/images/team/narciss.jpg", initials: "TN", color: "bg-ocean/20 text-ocean" },
  { name: "BAYISENGE PROTOGENE", role: "Recovery Committee Member", department: "Loan Recovery Committee", bio: "", image: "/images/team/protogene.jpg", initials: "BP", color: "bg-gold/20 text-chocolate" },
  { name: "MUZERWA Samuel", role: "Recovery Committee Member", department: "Loan Recovery Committee", bio: "", image: "/images/team/samuel.jpeg", initials: "MS", color: "bg-primary/20 text-primary" },
  { name: "HABIMANA Benoit", role: "Recovery Committee Member", department: "Loan Recovery Committee", bio: "", image: "/images/team/benoit.jpg", initials: "HB", color: "bg-forest/20 text-forest" },
];

const ictCommission = [
  { name: "IMANANIYOGAKIZA Samuel", role: "ICT Committee President", department: "ICT Commission", bio: "", image: "/images/team/sam.jpg", initials: "IS", color: "bg-primary/20 text-primary" },
];

const operationsTeam = [
  { name: "NDAYISENGA Jean Isaac", role: "Director of Liaison", department: "Operations Team", bio: "", image: "/images/team/jeanisaac.png", initials: "NJ", color: "bg-primary/20 text-primary" },
  { name: "ISIMBI ISHIMWE Ange", role: "Accountant & Public Relation Officer", department: "Operations Team", bio: "", image: "/images/team/ange-isimbi.jpg", initials: "IA", color: "bg-gold/20 text-chocolate" },
  { name: "Maxime Blaise", role: "Loan Officer", department: "Operations Team", bio: "", image: "/images/team/maxime.jpeg", initials: "MB", color: "bg-chocolate/20 text-chocolate" },
  { name: "MIHIGO DANIEL", role: "Loan Officer", department: "Operations Team", bio: "", image: "/images/team/danny.jpeg", initials: "MD", color: "bg-chocolate/20 text-chocolate" },
];

const sections = [
  { id: "board", tag: "Governance", title: "Board of Directors", desc: "Our elected board provides strategic oversight and ensures MFSC remains accountable to its members and true to its cooperative values.", members: boardMembers, cols: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5", accent: "border-l-chocolate" },
  { id: "audit", tag: "Oversight", title: "Audit Committee", desc: "Ensuring financial transparency, internal controls, and regulatory compliance across all MFSC operations.", members: auditCommittee, cols: "grid-cols-2 sm:grid-cols-3", accent: "border-l-gold" },
  { id: "credit", tag: "Lending", title: "Credit Committee", desc: "Managing credit policy, loan approvals, and ensuring responsible lending practices that protect both members and the cooperative.", members: creditCommittee, cols: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5", accent: "border-l-forest" },
  { id: "recovery", tag: "Collections", title: "Loan Recovery Committee", desc: "Working with members facing repayment challenges to find sustainable solutions while protecting the cooperative's financial health.", members: loanRecoveryCommittee, cols: "grid-cols-2 sm:grid-cols-4", accent: "border-l-chocolate" },
  { id: "ict", tag: "Technology", title: "ICT Commission", desc: "Leading MFSC's digital transformation to provide faster, more efficient, and paperless services to all members.", members: ictCommission, cols: "grid-cols-2 max-w-2xl", accent: "border-l-ocean" },
  { id: "operations", tag: "Management", title: "Operations Team", desc: "Our executive leadership team managing daily operations, member services, and ensuring MFSC delivers on its mission every day.", members: operationsTeam, cols: "grid-cols-2 sm:grid-cols-2 lg:grid-cols-4", accent: "border-l-primary" },
];

// ─── CARD ───────────────────────────────────────────────
const TeamCard = ({ person }: { person: typeof boardMembers[0] }) => {
  const [imageError, setImageError] = useState(false);
  const showImage = !imageError && person.image;

  return (
    <div className="group relative rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 border border-border hover:border-primary/20">
      <div className="relative w-full aspect-[3/4] bg-muted overflow-hidden">
        {showImage ? (
          <img
            src={person.image}
            alt={person.name}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className={`w-full h-full flex items-center justify-center ${person.color} text-4xl font-heading font-bold`}>
            {person.initials}
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-foreground/90 via-foreground/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <p className="text-xs font-body font-semibold uppercase tracking-wider" style={{ color: "hsl(var(--gold))" }}>
            {person.department}
          </p>
        </div>
      </div>
      <div className="bg-card px-4 py-3 border-t border-border">
        <h3 className="font-heading font-bold text-foreground text-sm leading-tight">{person.name}</h3>
        <p className="text-xs font-body text-muted-foreground mt-0.5">{person.role}</p>
      </div>
    </div>
  );
};

// ─── SECTION (drop this onto your homepage) ─────────────
const TeamSection = () => {
  return (
    <div id="team">
      {/* Sticky jump nav */}
      <div className="sticky top-[5.5rem] z-40 bg-background/90 backdrop-blur border-b border-border">
        <div className="container-max px-4 sm:px-6 lg:px-8">
          <div className="flex gap-1 overflow-x-auto py-3">
            {sections.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                className="shrink-0 px-4 py-1.5 rounded-full text-xs font-body font-semibold text-muted-foreground hover:text-foreground hover:bg-muted transition-colors whitespace-nowrap"
              >
                {s.title}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Subsections */}
      {sections.map((section, idx) => (
        <section
          key={section.id}
          id={section.id}
          className={`section-padding ${idx % 2 === 1 ? "bg-warm" : "bg-background"}`}
        >
          <div className="container-max px-4 sm:px-6 lg:px-8">
            <div className={`border-l-4 ${section.accent} pl-5 mb-12`}>
              <span className="text-xs font-body font-semibold text-forest uppercase tracking-widest">{section.tag}</span>
              <h2 className="font-heading text-3xl sm:text-4xl font-bold text-foreground mt-2 mb-3">{section.title}</h2>
              <p className="text-muted-foreground font-body max-w-2xl leading-relaxed">{section.desc}</p>
            </div>
            <div className={`grid ${section.cols} gap-5`}>
              {section.members.map((person) => (
                <TeamCard key={person.name} person={person} />
              ))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default TeamSection;